const cookieService = {
  setCookie(cname, cvalue, expireDays = 10) {
    const d = new Date()
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000)
    const expires = "expires=" + d.toUTCString()
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
  },
  removeCookie(cname) {
    document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:00 UT; path=/;"
  },
  removeAllCookies() {
    const cookies = document.cookie.split(";")
    // set past expiry to all cookies
    for (let i = 0; i < cookies.length; i++) {
      document.cookie = cookies[i] + "=; expires=" + new Date(0).toUTCString()
    }
  },
  getCookie(cname) {
    const name = cname + "="
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(";")
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == " ") {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  },
  createTlaspheCookie() {
    cookieService.setCookie(
      "_ga_24Args",
      String(Date.now().toString(32) + Math.random().toString(16)).replace(
        /\./g,
        ""
      )
    )
  }
}

export default cookieService
